<div class="alert" [class]="color" [style.justifyContent]="revision ? 'space-between' : '' ">
  @if (noIcon.length) {
    <div class="alert--icon">
      <mat-icon>{{ setIcon(color) }}</mat-icon>
    </div>
  }
  <div tabindex="0" [class]="display">
    <div class="alert--header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="alert--content">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>

  @if (revision.length) {
    <div class="revision-butttons">
      <button class="cancel" (click)="emitRevisionAction('cancelAccessRevision')" [disabled]="isLoading"><strong>Não, cancelar</strong></button>
      @if (revision === 'block') {
        <button class="block-access" (click)="emitRevisionAction('blockAccessRevision')"><strong>Sim, bloquear acesso</strong></button>
      }
      @if (revision === 'renovate') {
        <button class="renovate-access" (click)="emitRevisionAction('renovateAccessRevision')" [disabled]="isLoading"><strong>Sim, renovar acesso</strong></button>
      }
    </div>
  }

  @if (close) {
    <div
      tabindex="0"
      class="alert--close"
      (keydown)="keyboardClose($event)"
      >
      <a
        style="text-decoration: none"
        role="button"
        class="d-flex align-items-center"
        aria-label="Fechar mensagem"
        (click)="hasClosed.emit()"
        >
        <mat-icon>close</mat-icon>
      </a>
    </div>
  }
</div>
